// extracted by mini-css-extract-plugin
export default {"card":"Card_card__df6FJ","content":"Card_content__yNQr9","desc":"Card_desc__J8XmB","img":"Card_img__4+LNG","price":"Card_price__i8hkM","more":"Card_more__qJWYk"};